import axiosInstance from '../utils/axios'

const apiPath = '/api/product'

const ProductApi = {
  getById: function (shopifyId) {
    return axiosInstance.get(`${apiPath}/${shopifyId}`)
  }
}

export default ProductApi